import { Person } from './person';

export interface WaiverSignatureModel {
  person?: Person;
  signature?: string;
}
